import { themeAlpine } from "ag-grid-community";

export const PYBaseTableTheme = themeAlpine.withParams({
	//spacing
	rowHeight: 48,
	headerHeight: 44,
	borderRadius: 4,
	cellHorizontalPadding: 4,

	//typography
	fontFamily: "Source Sans Pro, sans-serif",
	cellFontFamily: "Source Sans Pro, sans-serif",
	fontSize: "14px",
	headerFontWeight: "600",
	headerFontSize: "14px",
	headerFontFamily: "Source Sans Pro, sans-serif",

	//backgroundColors
	backgroundColor: "var(--py-neutral-0)",
	headerBackgroundColor: "var(--py-neutral-1)",
	borderColor: "var(--py-neutral-2)",
	rowHoverColor: "transparent",
	selectCellBackgroundColor: "var(--py-primary-1)",
	oddRowBackgroundColor: "var(--py-primary-0)",
});
